const dictionaryFriendlyNames: Record<string, string> = {
  // College dictionaries
  CET4_T: "CET-4",
  CET6_T: "CET-6",
  xinghuoqiaoji_4: "四级巧记速记",
  xinghuoqiaoji_6: "六级巧记速记",
  DanCiDeJianFa_4: "CET-4-Sub",
  DanCiDeJianFa_6: "CET-6-Sub",
  Level4luan_2_T: "专四",
  Level8luan_2_T: "专八",
  "3000_ClassRoom_English_Words": "专升本3000词",

  // Graduate dictionaries
  KaoYan_3_T: "考研",
  KaoYan_2024: "考研 2024",
  KaoYanShanGuo_2023: "考研闪过 2023",
  "926": "考研926词汇",
  DanCiDeMimi_1: "单词的秘密-英语一",
  DanCiDeMimi_2: "单词的秘密-英语二",
  "2024HongBao_T1": "2024考研英语hongbaoshu(上)",
  "2024HongBao_T2": "2024考研英语hongbaoshu(下)",
  "hongbaoshu-2026": "2026考研英语 hongbaoshu",
  English_II: "英语二单词书",
  kaoyanshanguo2025: "考研 shangguo 2025",
  "2025KaoYanHongBaoShu": "2025考研英语词汇hongbao书",

  // TOEFL dictionaries
  TOEFL_3_T: "TOEFL",
  TOEFL_ZhangHongYan: "ZhangHongYan的TOEFL词汇书",

  // Professional dictionaries
  archVocabulary: "建筑专业英语",
  itVocabulary: "计算机专用英语",

  // PET dictionaries
  PETS_3: "PETS",
  PETS_2023: "PETS-2023",
  "pet-vacabulary-list-2024": "PET-2024",

  // GMAT dictionaries
  GMAT_3_T: "GMAT 词库",

  // GRE dictionaries
  GRE_3_T: "GRE",
  GRE_1500: "GRE重点1500词-fen哥",
  GRE3000_3_T: "GRE3000",
  "GRE-computer-based-test": "GRE机经词汇",
  ZaiYaoNiMing_GRE3000: "再要你命GRE3000",
  GRE_equivalent: "GRE等价词",
  "gre-ciyileiji": "GRE词以类记",

  // IELTS dictionaries
  IELTS_tinglichangjing: "雅思听力场景词汇",
  IELTS_disorder: "IELTS乱序完整版",
  IELTS_order: "IELTS剑桥完整版",
  IELTS_3_T: "IELTS",
  HeQiong_IELTS: "heQiong雅思听力必考词汇",
  IELTS_WANG_3: "雅思wang C3",
  IELTS_WANG_4: "雅思wang C4",
  IELTS_WANG_5: "雅思wang C5",
  IELTS_WANG_11: "雅思wang C11",
  DuckCircle_IELTS: "鸭题雅思核心词",
  IELTSVocabularyBible: "雅思词汇真经",
  "ielts-807": "雅思 wanglu 807",
  IELTS9988wangyong: "雅思9988wangyong",
  IELTSKingLu807: "wanglu807雅思词汇听力方法2版",
  IELTS_XDF_7000: "100个句子记7000个雅思单词",
  "IELTS-oral-900": "雅思口语 900 beta版",

  // KET dictionaries
  ket2021: "KET",

  // SAT dictionaries
  SAT_3_T: "SAT",
  SATen: "SAT en-cn",

  // BEC dictionaries
  BEC_2_T: "商务英语",
  BEC_3_T: "BEC",

  // PTE dictionaries
  PTE_junior: "PTE 基础词汇",
  PTE_senior: "PTE 高阶词汇",
  PTE_FIB_R_junior: "阅读 FIB 基础机经词汇",
  PTE_FIB_R_senior: "阅读 FIB 高阶机经词汇",
  PTE_WFD: "WFD 机经词汇",
  PTE_FIB_L: "听力 FIB 机经词汇",
  PTE_Basic_apeuni: "PTE 基础词汇 xingji",
  PTE_Advanced_apeuni: "PTE 高阶词汇 xingji",
  PTE_Read_apeuni: "PTE 阅读FIB机经词汇 xingji",
  PTE_Listening_apeuni: "PTE 听力FIB机经词汇 xingji",
  "Common-Phrases-PTE-Unofficial": "PTE 常用短语 (非官方)",

  // TOEIC dictionaries
  TOEIC: "TOEIC 词汇",

  // CEFR dictionaries
  Duolingo_Vocabulary_B1: "多邻国分级词汇B1",
  Duolingo_Vocabulary_B2: "多邻国分级词汇B2",
  Duolingo_Vocabulary_C1: "多邻国分级词汇C1",

  // Oxford dictionaries
  Oxford3000: "牛津3000词",
  Oxford5000: "牛津5000词",

  // Other dictionaries
  voa: "VOA 基础词库",
  "Common-Phrases-FCE-Unofficial": "FCE 常用短语 (非官方)",

  // Self-study dictionaries
  "self-study_English1": "自考1800高频单词",
  "self-study_English2": "自考英语二高频悠悠单词",
  "self-study_English3": "自考英语二完整单词",

  // More dictionaries
  coca20000: "COCA20000词",
  "4000_Essential_English_Words-meaning": "Essential Words",
  "4000_Essential_English_Words-sentence": "Essential Words",
  Longman_Communication_3000: "Longman Communication 3000",
  top2000words: "Top 2000 words",
  Top1500NounWords: "Top 1500 Nouns",
  Top1000VerbWords: "Top 1000 Verbs",
  Top500AdjectiveWords: "Top 500 adj.",
  Top250AdverbWords: "Top 250 adv.",
  Top60Pronouns: "Top 60 pron.",
  Top50Prepositions: "Top 50 prep.",
  suffix_word: "suffix word",
  word_roots1: "word roots1",
  "adult-self-study-examination": "专升本词汇",
  "zhuan-cha-ben": "专插本英语词汇",
  xueshiyingyu: "专升本学士学位的英语",
  "Merriam_Webster_sVocabularyBuilder": "韦氏词根词典",
  tingshuokaoshi: "听说考试常见词汇",
  frequently_used_word01: "超频单词level 1",
  frequently_used_word02: "超频单词level 2",
  frequently_used_word03: "超频单词level 3",
  Macmillan7000: "麦克米伦7000",
};

export const resolveDictionaryDisplayName = (
  dictionaryFile?: string | null
): string | undefined => {
  if (!dictionaryFile) {
    return undefined;
  }

  const fileName = dictionaryFile.replace(/\.json$/i, "");
  const exactMatch = dictionaryFriendlyNames[fileName];

  if (exactMatch) {
    return exactMatch;
  }

  const lowerFileName = fileName.toLowerCase();

  for (const [key, value] of Object.entries(dictionaryFriendlyNames)) {
    const lowerKey = key.toLowerCase();
    if (lowerFileName.includes(lowerKey) || lowerKey.includes(lowerFileName)) {
      return value;
    }
  }

  const fallbackName = fileName
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!fallbackName) {
    return undefined;
  }

  return fallbackName.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const dictionaryFriendlyNameMap = dictionaryFriendlyNames;
